import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

class navLink {
  constructor(display, path, displayState) {
    this.display = display;
    this.path = path;
    this.displayState = displayState;
  }
  display;
  path;
  displayState;
}

const navLinks = [
  new navLink("Home", "/"),
  new navLink("FAQ Videos", "/faqvideo"),
  new navLink("Pamphlets", "/pamphlet"),
  new navLink("About", "/about"),
  new navLink("Contact", "/contact")
];

export const Nav = () => {
  const toggleNav = () => {
    const element = document.getElementById("TopNav");
    if (!element) return;
    element.className =
      element.className === "topnav" ? "topnav responsive" : "topnav";
  };

  return (
    <div id="TopNav" className="topnav">
      <button type="button" className="icon" onClick={toggleNav}>
        <FontAwesomeIcon icon={faBars} /> Menu
      </button>
      {navLinks.map(link => (
        <NavLink
          key={link.path}
          to={link.path}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          {link.display}
        </NavLink>
      ))}
    </div>
  );
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return <div className="footer">&copy;{year}</div>;
};
